import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Modal } from '@shared/components/common/modal/modal';
import { ButtonComponent } from '@shared/components/ui/button/button.component';
import { CreationButtons } from '@shared/components/ui/creation-buttons/creation-buttons';

import {
  LocationCoordinates,
  LocationPickerComponent,
} from './location-picker.component';

export interface LocationPickerDialogData {
  latitud: string | number | null | undefined;
  longitud: string | number | null | undefined;
  readOnly: boolean;
}

@Component({
  selector: 'app-location-picker-dialog',
  imports: [ButtonComponent, CreationButtons, LocationPickerComponent, Modal],
  templateUrl: './location-picker-dialog.component.html',
})
export class LocationPickerDialogComponent {
  readonly data = inject<LocationPickerDialogData>(MAT_DIALOG_DATA);
  selectedCoordinates = this.getInitialCoordinates();

  private readonly dialogRef = inject(
    MatDialogRef<LocationPickerDialogComponent, LocationCoordinates | undefined>,
  );

  onCoordinatesChange(coordinates: LocationCoordinates): void {
    this.selectedCoordinates = coordinates;
  }

  confirm(): void {
    if (this.selectedCoordinates && !this.data.readOnly) {
      this.dialogRef.close(this.selectedCoordinates);
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  private getInitialCoordinates(): LocationCoordinates | null {
    const latitud = this.parseCoordinate(this.data.latitud, -90, 90);
    const longitud = this.parseCoordinate(this.data.longitud, -180, 180);

    return latitud === null || longitud === null
      ? null
      : { latitud: String(latitud), longitud: String(longitud) };
  }

  private parseCoordinate(
    value: string | number | null | undefined,
    min: number,
    max: number,
  ): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const coordinate = Number(value);
    return Number.isFinite(coordinate) && coordinate >= min && coordinate <= max
      ? coordinate
      : null;
  }
}
